import React, { Component } from 'react';
import WithNavigation from '../../layouts/WithNavigation';

import KeyContactDetails from './KeyContactDetails';

class KeyContact extends Component {
    render(){
      const { location } = this.props;
      let  keyContact = location && location.state && location.state.keyContact;
      
        if(keyContact){
            return(
                <WithNavigation
                    title={`${keyContact.name}`} 
                    top={(
                        <KeyContactDetails 
                            keyContact={keyContact}
                        />
                    )}
                />
            )
        }
    }
}

export default KeyContact;